<template>
    <div class="row justify-content-center">
        <div v-if="isEmpty(documents)" class="col-12">
            <h5 class="tx-color-01 mg-b-5 tx-center">Empty.</h5>
            <p class="tx-color-03 tx-13 tx-center">No Documents available at the moment.</p>
        </div>

        <div v-else class="col-12">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="wd-30p" scope="col">Date</th>
                        <th scope="col">Name</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="document in documents">
                        <td>{{ document.created_at|toDate('Do MMMM YYYY') }}</td>
                        <td>{{ document.name }}</td>
                        <td>
                            <a :href="document.url" target="_blank">Download</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
	.table th {
		border-top: none;
	}
</style>

<script>
	export default {
		mounted() {},
		props: ["documents"]
	};
</script>
